import DocumentListPanel from 'Components/Generic/Documents/DocumentListPanel';
import DocumentData from 'Data/DocumentData';
import ServiceContractDetailsDocumentData from 'Data/ServiceContractDetailsDocumentData';
import PropTypes from 'prop-types';

const ServiceContractDetailsDocumentsPanel = ({
  serviceContractDetails = {},
  ...props
}) => {
  return (
    <DocumentListPanel
      editable
      returnTableOnly
      hideTypeColumn
      documentType={'Service Contract'}
      documents={serviceContractDetails?.documents}
      uploadDocFunc={(file) =>
        DocumentData.uploadServiceContractDetailsDocument(
          file,
          serviceContractDetails?.id,
        )
      }
      deleteDocFunc={(docObj) =>
        ServiceContractDetailsDocumentData.deleteDocument(
          docObj,
          serviceContractDetails?.id,
        )
      }
      {...props}
    />
  );
};

ServiceContractDetailsDocumentsPanel.propTypes = {
  serviceContractDetails: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  canAddDoc: PropTypes.bool,
  disabled: PropTypes.bool,
  onDocumentsUpdated: PropTypes.func,
};

export default ServiceContractDetailsDocumentsPanel;
